(function () {
  var PENDING_CLASS = 'stamped-reviews--pending';
  var REVEAL_DELAY_MS = 1200;
  var REVEAL_DELAY_DYNAMIC_MS = 400;
  var FALLBACK_MS = 3000;
  var OVERRIDES_ID = 'stamped-theme-overrides';

  var STAMPED_OVERRIDES_CSS = [
    'body .card .stamped-reviews{text-align: center;}',
    'body .card .stamped-reviews a{text-decoration:none!important;color:#292929!important}',
    'body .card .stamped-reviews a:hover{color:#ff721f!important}',
    'body .card .stamped-product-reviews-badge{display:inline-flex!important;align-items:center!important;flex-wrap:wrap!important;gap:2px 4px!important}',
    'body .card .stamped-product-reviews-badge .stamped-badge{display:flex!important;align-items:center!important;justify-content:center!important}',
    'body .card .stamped-product-reviews-badge .stamped-badge .stamped-starrating i{color:#ff721f!important}',
    'body .card .stamped-product-reviews-badge .stamped-badge .stamped-badge-caption{margin-bottom:0!important;font-family:"Circular Std",sans-serif!important;font-size:18px!important;color:#292929!important}',
    'body .card .stamped-product-reviews-badge .stamped-badge .stamped-badge-caption::after{display:none!important}',
    'body .card .stamped-product-reviews-badge .stamped-reviews-label{font-family:"Circular Std",sans-serif!important;font-size:18px!important;color:#292929!important;letter-spacing:0!important}',
    '@media (max-width:749px){body .card .stamped-product-reviews-badge .stamped-badge .stamped-badge-caption{font-size:15px!important}}',
    '@media (max-width:749px){body .card .stamped-product-reviews-badge .stamped-badge .stamped-fa-star{font-size:15px!important}}',
    '@media (max-width:749px){body .card .stamped-product-reviews-badge .stamped-reviews-label{font-size:15px!important}}'
  ].join('');

  function injectOverrides() {
    if (document.getElementById(OVERRIDES_ID)) return;
    var style = document.createElement('style');
    style.id = OVERRIDES_ID;
    style.textContent = STAMPED_OVERRIDES_CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function revealElements(elements) {
    if (!elements || !elements.length) return;
    injectOverrides();
    requestAnimationFrame(function () {
      elements.forEach(function (el) {
        if (el.classList.contains(PENDING_CLASS)) {
          el.classList.remove(PENDING_CLASS);
          el.style.visibility = '';
        }
      });
    });
  }

  function revealAll() {
    var list = document.querySelectorAll('[data-stamped-reviews].' + PENDING_CLASS);
    revealElements(Array.prototype.slice.call(list));
  }

  window.addEventListener('load', function () {
    injectOverrides();
    setTimeout(revealAll, REVEAL_DELAY_MS);
  });

  setTimeout(function () {
    revealAll();
  }, FALLBACK_MS);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var toReveal = [];
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-stamped-reviews].' + PENDING_CLASS)) {
            toReveal.push(node);
          }
          if (node.querySelectorAll) {
            var children = node.querySelectorAll('[data-stamped-reviews].' + PENDING_CLASS);
            toReveal.push.apply(toReveal, Array.prototype.slice.call(children));
          }
        });
      });
      if (toReveal.length) {
        setTimeout(function () {
          revealElements(toReveal);
        }, REVEAL_DELAY_DYNAMIC_MS);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
